exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (max-width:767px){#news-view #year-selector-dropdown{display:none}#news-view #tab-selector-year{left:70%;width:30%;display:inherit}#news-view #tab-selector-base{width:70%}#news-view #tab-selector-base .mdl-tabs__tab{border-right:1px solid #e0e0e0}#news-view .tab-select-icon{right:12px}#news-view section{padding:16px}#news-view section:not(:first-child){padding-top:0}#news-view section:last-child{padding-bottom:16px}#news-view .container{margin:0 auto}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js!./~/sass-loader!./~/vue-loader/lib/selector.js?type=style&index=1!./assets/component/news/news-page.vue
// module id = 281
// module chunks = 0